import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField, Paper } from "@mui/material";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../Components/Sidebar/sidebar";
import '../css/vehicles.css';
import SearchBar from "../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../config/appColors";
import { postRequest } from "../Api";
import { apiRoutes } from "../Api/apiRoutes";
import { setLoader } from "../Redux/Reducers/gernalSlice";
import VehicleView from "../Components/VehicleView";
import { Grid } from "@mui/system";


const AllVehicles = () => {


  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:700px)");


  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector((state) => state.authReducer.user);
  const [activeTab, setActiveTab] = React.useState('allVehicles');
  const [vehicles, setVehicles] = useState([]);
  const [tempVehicles, setTempVehicles] = useState([]);




  const getAllCars = async () => {

    const onSuccess = (res) => {
      setVehicles(res.data?.reverse());
      setTempVehicles(res.data?.reverse());
    }

    const onError = (err) => {
      console.log('err', err);
    }

    dispatch(setLoader(true));
    const body = {
      token: user?.token
      //
    }

    await postRequest(body, apiRoutes.getAllVehicles, onSuccess, onError)

  }

  const filterVehicles = (type) => {
    setActiveTab(type);
    if (type == 'allVehicles') {
      setVehicles(tempVehicles.reverse());
    }
    else if (type == 'availableVehicles') {
      const availableVehicles = tempVehicles.filter((item) => item.is_booked == '0');
      setVehicles(availableVehicles.reverse());
    }
    else if (type == 'rentedvehicles') {
      const rentedVehicles = tempVehicles.filter((item) => item.is_booked == '1');
      setVehicles(rentedVehicles.reverse());
    }
  }


  useEffect(() => {
    getAllCars();
  }, [])


  return (
    <>
      <ThemeProvider theme={theme}>
        <div style={{ display: 'flex', }}>
          <Sidebars />

          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
            <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
              Vehicles
            </span>
            <div style={{

            }} className="media-display">
              <div
                style={{
                  ...tabContainer,
                  width: isMobile ? "100%" : "40%",
                  // overflowX: isMobile ? "auto" : "unset",
                  // whiteSpace: isMobile ? "nowrap" : "normal",
                }}
              >
                <div
                  onClick={() => filterVehicles('allVehicles')}
                  style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}>
                  <Typography sx={tabText} >
                    All Vehicles
                  </Typography>
                  {activeTab == 'allVehicles' && <div style={focusedTabLine} />}
                </div>
                <div
                  style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                  onClick={() => filterVehicles('availableVehicles')}
                >
                  <Typography sx={tabText} >
                    Available Vehicles
                  </Typography>
                  {activeTab == 'availableVehicles' && <div style={focusedTabLine} />}
                </div>
                <div
                  style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', cursor: 'pointer', }}
                  onClick={() => filterVehicles('rentedvehicles')}
                >
                  <Typography sx={tabText} >
                    Rented Vehicles
                  </Typography>
                  {activeTab == 'rentedvehicles' && <div style={focusedTabLine} />}
                </div>

              </div>
              <div className="searchBar-Container" style={{ position: 'relative', display: 'flex',marginTop:20, alignItems: 'center' }}>
                <input
                  onChange={(e) => {
                    if (activeTab) setActiveTab('');
                    const value = e.target.value?.toLowerCase();
                    if (!value) setVehicles(vehicles);
                    const filteredVehicles = tempVehicles?.filter((item) => {
                      return item.veh_name.toLowerCase().includes(value) || item.reg_no.toLowerCase().includes(value) || item.model.toLowerCase().includes(value) || item.make.toLowerCase().includes(value) || item.year.toLowerCase().includes(value)
                    });
                    setVehicles(filteredVehicles);
                  }}
                  placeholder="Search Vehicle"
                  style={{
                    border: "none",
                    fontFamily: 'Poppins',
                    outline: "none",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "white",
                    borderRadius: 10,
                    height: 50,
                    paddingLeft: 20, // Adjusted for space on left
                    paddingRight: 40, // Space for the search icon
                    fontSize: 13,
                  }}
                />

                <SearchIcon
                  style={{
                    color: appColors.primary,
                    fontSize: 20,
                    position: 'absolute',
                    right: 10, // Position it on the right
                  }}
                />
              </div>

            </div>

            {/* Vehicles Grid */}
            {vehicles.length === 0 ? (
              <Paper sx={{ p: 8, textAlign: "center", borderRadius: 3, bgcolor: "white" }}>
                <Typography variant="h6" color="text.secondary" fontFamily="Poppins">
                  No vehicles found
                </Typography>
              </Paper>
            ) : (
              <Grid container spacing={3}>
                {vehicles.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <VehicleView vehicle={item} />
                  </Grid>
                ))}
              </Grid>
            )}
          </div>
        </div>
      </ThemeProvider>
    </>
  )

}



const tabContainer = {
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'white',
  width: "40%",
  borderRadius: 15,
  paddingTop: 10, paddingRight: 20, paddingLeft: 20,
  justifyContent: 'space-between',
  boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',


}
const tabText = {
  fontSize: 14,
  color: '#000000',
  fontFamily: 'Poppins',


}

const focusedTabLine = {
  backgroundColor: appColors.primary,
  width: 55,
  height: 2,
  marginTop: 5

}

// const searchBarContainer = {
//   display: 'flex',
//   flexDirection: 'row',
//   width: '30%',
//   // marginTop: 20,
//   marginLeft: 20,
//   borderRadius: 15,
//   paddingLeft: 10,
//   paddingRight: 10,
//   paddingTop: 10,
//   paddingBottom: 10,
//   backgroundColor: appColors.white,
//   boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',
//   height: 25,



// }



export default AllVehicles
